<template>
    <div>
        <el-dialog title="选择印章" :visible.sync="dialogVisible" width="70%" >
            <div>
                <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="上传图片" name="first">
                        <fileraw ref="fileraw"></fileraw>
                    </el-tab-pane>
                    <el-tab-pane label="手写签名" name="second">
                        <SignaturePad ref="signatureRef"></SignaturePad>
                    </el-tab-pane>
                </el-tabs>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="getcropAndGetBase64">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import fileraw from './fileraw.vue';
import SignaturePad from './SignaturePad.vue';
export default{
    name:"",
    components:{
        fileraw,
        SignaturePad,
    },
    data(){
        return{
            dialogVisible:false,
            activeName:'first',
        }
    },
    mounted(){
        
    },
    methods:{
        handleClick(tab, event){
            if(tab.index == 1){
                if(this.$refs.signatureRef.isEmpty){
                    this.$refs.signatureRef.initCanvas()
                }
            }
        },
        //确定
        getcropAndGetBase64() {
            if(this.activeName == 'first'){
                // this.cropAndGetBase64();
                this.$refs.fileraw.cropAndGetBase64()
                this.dialogVisible = false;
                this.$emit('changesignimg',{
                    url:this.$refs.fileraw.croppedBase64,
                    width:this.$refs.fileraw.cropSize,
                    height:this.$refs.fileraw.cropSize
                })
            }else if(this.activeName == 'second'){
                this.$refs.signatureRef.saveSignature()
                this.dialogVisible = false;
                this.$emit('changesignimg',{
                    url:this.$refs.signatureRef.signatureDataUrl,
                    width:270,
                    height:120
                })
            }
            

        },
    }
}
</script>
<style scoped>
    
</style>